import { WalletCardType } from "../../Wallet/types";

const SDK_ID_TO_INTERNAL: Record<string, WalletCardType> = {
  virtual: WalletCardType.Virtual,
  physical: WalletCardType.Physical
};

const ALL_CARD_TYPES = [WalletCardType.Virtual, WalletCardType.Physical];

export const parseAllowedCardTypes = (queryParam: string): WalletCardType[] => {
  const requested = queryParam
    .split(",")
    .map(value => SDK_ID_TO_INTERNAL[value.trim()])
    .filter(Boolean);

  const allowed = ALL_CARD_TYPES.filter(type => requested.includes(type));

  return allowed.length > 0 ? allowed : ALL_CARD_TYPES;
};
